export default __webpack_public_path__ + "static/media/IMG_52071.963411cc.jpg";